export const education = [
    {
        "date": "Completude",
        "title": "Praticidade",
        "category": "Transparência",
        "description": "Garantir total transparência entre lojistas e afiliados, proporcionando uma gestão simplificada e acessível. Ambas as partes podem monitorar o desempenho, acesso a dados e ferramentas em tempo real, promovendo confiança e eficiência nas operações."
    },
    {
        date: "Escalabilidade",
        title: "Aumento de Vendas",
        category: "Crescimento",
        description: "Impulsionar as vendas por meio de parcerias estratégicas, proporcionando aos afiliados acesso a ferramentas necessárias para promover produtos de forma eficaz, aumentando a receita para todos, garantindo que nossos parceiros tenham todos os recursos necessários."
    },
    {
        date: "Produtividade",
        title: "Incentivos Atrativos",
        category: "Motivação",
        description: "Incentivos e comissões que recompense o desempenho dos afiliados, motivando-os a alcançar resultados cada vez melhores e fortalecendo a parceria entre nós e nossos parceiros, construímos uma rede de parcerias robusta e eficiente."
    }

]